<template>
    <div class="privacy-policy-area">
        <div class="container">
            <div class="privacy-policy-content">
                <h2>Overview</h2>
                <p>At <strong>Meander Software,</strong> your privacy is important to us. This Privacy Policy explains
                    how we collect, use, disclose, and safeguard your information when you visit our website or engage
                    with our services. Please read this policy carefully. By using our website or services, you consent
                    to the practices described here.</p>
                <h5>1. Information We Collect</h5>
                <p>We may collect the following types of information:</p>
                <p><strong>Personal Information:</strong> Name, email address, phone number, company name, and other
                    information you provide when filling out forms, subscribing to newsletters, or contacting us.
                    <br>
                    <strong>Non-Personal Information: </strong> Browser type, IP address, device information, pages
                    visited, and other analytics data collected automatically through cookies and tracking technologies.
                    <br>
                    <strong>Transactional Information:</strong> Records of services you purchase or inquiries you make
                    with us.
                </p>
                <h5>2. How We Use Your Information</h5>
                <p><strong>We use your information to:</strong></p>
                <ul>
                    <li>Respond to inquiries and provide requested services.</li>
                    <li>Improve our website, products, and services.</li>
                    <li>Send updates, newsletters, or marketing communications (with your consent). </li>
                    <li>Comply with legal obligations and protect our rights. </li>
                    <li>Analyze trends and usage to enhance user experience.</li>

                </ul>
                <h5>3. How We Share Your Information</h5>
                <p>We do not sell, rent, or trade your personal information. We may share your information in
                        the following cases:</p>
                <p><strong>Service Providers:</strong> Trusted partners who perform services on our behalf (e.g., cloud
                    hosting, analytics, marketing).</p>
                <h2>Intellectual property</h2>
                <p><strong>Legal Compliance</strong> When required by law or to protect our rights, property, or safety.
                </p>
                <p><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your
                    information may be transferred as part of the business transaction.</p>

                <h5>4. Cookies and Tracking Technologies</h5>
                <p>We use cookies, pixels, and other tracking technologies to enhance your experience on our website.
                    These tools help us:</p>
                <ul>
                    <li>Understand website usage and performance.</li>
                    <li>Personalize content and marketing messages.</li>
                    <li>Improve website functionality.</li>
                </ul>
                <p>You can manage or disable cookies through your browser settings, but some features of the website may
                    not function properly</p>


                <h5>5. Data Security</h5>
                <p>We implement appropriate technical and organizational measures to protect your information from
                    unauthorized access, disclosure, alteration, or destruction. While we strive to secure your data, no
                    method of transmission over the internet is 100% secure.</p>

                <!-- <p>Last updated: January 25, 2021 at 24:00 pm</p> -->
                <p>Last updated: 6 August 2025</p>


                <h5>6. Your Rights</h5>
                <p>Depending on your location, you may have rights regarding your personal data, including:</p>
                <ul>
                    <li>Accessing the information we hold about you.</li>
                    <li>Requesting correction or deletion of your data.</li>
                    <li>Opting out of marketing communications.</li>
                    <li>Restricting or objecting to data processing.</li>
                </ul>
                <p>
                    To exercise these rights, please contact us at
                    <a href="mailto:hi@meander.software">hi@meander.software</a>
                </p>

                <h5>7. Third-Party Links</h5>
                <p>Our website may contain links to third-party websites. We are not responsible for the privacy
                    practices or content of these external sites. We encourage you to read their privacy policies.</p>


                <h5>8. Children’s Privacy</h5>
                <p>Our website and services are not intended for children under 13. We do not knowingly collect personal
                    information from children.</p>

                <h5>9. Changes to This Privacy Policy</h5>
                <p>We may update this policy from time to time. Updates will be posted on this page with the revised
                    effective date. We encourage you to review this policy periodically.</p>

                <h5>10. Contact Us</h5>
                <p>If you have any questions or concerns regarding this Privacy Policy or our data practices, please
                    contact us:t</p>
                <p>
                   <strong>Email:</strong> <a href="mailto:hi@meander.software">hi@meander.software</a>
                </p>
                <p>
                   <strong>Phone: </strong><a href="tel:+918090549054">(+91) 80-9054-9054</a>
                </p>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy'
}
</script>